import React, { FC } from 'react';
import { hot } from 'react-hot-loader/root';

import { Layout } from 'layout';
import { GlobalNotification } from './features/GlobalNotification';
import { Profile } from 'features/Profile';
import { SwitchRoutes } from 'pages/SwitchRoutes';
import { GlobalStyles } from 'theme';
import { AppWrapper } from './AppWrapper';
import { AuthSwitchWrapper } from './AuthSwitchWrapper';

const App: FC = () => (
  <AppWrapper>
    <GlobalStyles />
    <AuthSwitchWrapper>
      <Profile>
        <Layout>
          <GlobalNotification />
          <SwitchRoutes />
        </Layout>
      </Profile>
    </AuthSwitchWrapper>
  </AppWrapper>
);
export default hot(App);
